"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventListInUse = void 0;
var react_1 = __importDefault(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var storybook_1 = require("@eyecons/storybook");
var EventListInUse = function (_a) {
    var createClip = _a.createClip, deleteEvent = _a.deleteEvent, editEvent = _a.editEvent, items = _a.items;
    return (react_1.default.createElement("div", { className: 'storybook-producer-eliu' },
        react_1.default.createElement("div", { className: 'storybook-producer-eliu-wrapper' },
            items.length === 0 &&
                react_1.default.createElement("div", { className: 'storybook-producer-eliu-empty' }, "Nog geen events"),
            items.length > 0 && items.map(function (eventItemProps, index) {
                return react_1.default.createElement(storybook_1.Producer.EventItemInUse, __assign({ key: index, createClip: function (id, timestamp) { return createClip(id, timestamp); }, deleteEvent: function (id) { return deleteEvent(id); }, editEvent: function (id) { return editEvent(id); } }, eventItemProps));
            }))));
};
exports.EventListInUse = EventListInUse;
exports.EventListInUse.propTypes = {
    createClip: prop_types_1.default.func,
    deleteEvent: prop_types_1.default.func,
    editEvent: prop_types_1.default.func,
    items: prop_types_1.default.array
};
exports.EventListInUse.defaultProps = {
    createClip: function (id, timestamp) { return console.log('create clip', id, timestamp); },
    deleteEvent: function (id) { return console.log('delete event', id); },
    editEvent: function (id) { return console.log('edit event', id); },
    items: [],
};
